import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzDrawerModule, NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationModule, NzNotificationService } from 'ng-zorro-antd/notification';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { NzContextMenuService, NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzSliderModule } from 'ng-zorro-antd/slider';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NzAnchorModule,
    NzCardModule,
    NzButtonModule,
    NzDividerModule,
    NzSpinModule,
    NzDrawerModule,
    NzTabsModule,
    NzToolTipModule,
    NzRadioModule,
    NzTagModule,
    NzSwitchModule,
    NzFormModule,
    NzInputModule,
    NzDatePickerModule,
    NzSelectModule,
    NzInputNumberModule,
    NzAutocompleteModule,
    NzRadioModule,
    NzMenuModule,
    NzIconModule,
    NzTabsModule,
    NzToolTipModule,
    NzTableModule,
    NzDropDownModule,
    NzSpinModule,
    NzModalModule,
    NzPopconfirmModule,
    NzNotificationModule,
    NzMessageModule,
    NzTreeModule,
    NzCheckboxModule,
    NzPaginationModule,
    NzCardModule,
    NzTagModule,
    NzSkeletonModule,
    NzTimelineModule,
    NzEmptyModule,
    NzSliderModule
  ],
  providers: [
    NzNotificationService,
    NzContextMenuService,
    NzMessageService,
    NzModalService,
    NzDrawerService,
  ],
  exports: [
    CommonModule,
    NzAnchorModule,
    NzCardModule,
    NzButtonModule,
    NzDividerModule,
    NzSpinModule,
    NzDrawerModule,
    NzTabsModule,
    NzToolTipModule,
    NzRadioModule,
    NzTagModule,
    NzSwitchModule,
    NzFormModule,
    NzInputModule,
    NzDatePickerModule,
    NzSelectModule,
    NzInputNumberModule,
    NzAutocompleteModule,
    NzRadioModule,
    NzMenuModule,
    NzIconModule,
    NzTabsModule,
    NzToolTipModule,
    NzTableModule,
    NzDropDownModule,
    NzSpinModule,
    NzModalModule,
    NzPopconfirmModule,
    NzNotificationModule,
    NzMessageModule,
    NzTreeModule,
    NzCheckboxModule,
    NzPaginationModule,
    NzCardModule,
    NzTagModule,
    NzSkeletonModule,
    NzTimelineModule,
    NzEmptyModule,
    NzSliderModule
  ]
})
export class BaseUiModule { }
